export default __webpack_public_path__ + "static/MuscatMediaGroupoman-d5db54203904c5b3b751a816e60ca33c.jpg";